import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    clientName: {
      validations: []
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' }
      ]
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' }
      ]
    },
    eventextra3: {
      validations: [
        { type: 'required', message: 'Please select an option' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please select a date for your event' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    startTime: {
      validations: []
    },
    endTime: {
      validations: []
    },
    eventextra5: {
      validations: [
        { type: 'required', message: 'Please select an option' }
      ]
    },
    plannedguestcount: {
      validations: []
    },
    sitename: {
      validations: []
    },
    reference: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Let us know about your event!',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Small',
            label: 'First Name:*',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Small',
            label: 'Last Name:*',
            mapping: 'lastName'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Small',
            label: 'Client/Organization:',
            mapping: 'clientName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Small',
            label: 'Email:*',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Small',
            label: 'Contact Cell Phone Number:',
            mapping: 'telnumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Small',
            label: 'What type of event are you inquiring about?:',
            options: [
              { label: 'Corporate Event', value: 'Corporate Event'},
              { label: 'Social Event', value: 'Social Event' },
              { label: 'Wedding Event', value: 'Wedding Event' }
            ],
            mapping: 'eventextra3'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Small',
            label: 'Date of Event:*',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Small',
            label: 'Start Time:',
            mapping: 'startTime'
          },
          {
            type: 'text',
            size: 'Small',
            label: 'End Time:',
            mapping: 'endTime'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Small',
            label: '"Food Only" Approximate Budget:*',
            options: [
              { label: '$8-$10', value: '$8-$10'},
              { label: '$10-$20', value: '$10-$20' },
              { label: '$20-$25', value: '$20-$25' },
              { label: '$25-$35', value: '$25-$35' },
              { label: '$35-$50', value: '$35-$50' },
              { label: '$50+', value: '$50+' },
            ],
            mapping: 'eventextra5'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Small',
            label: 'Number of Guests:',
            mapping: 'plannedguestcount'
          },
          {
            type: 'text',
            size: 'Small',
            label: 'Event Location:',
            mapping: 'sitename'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Small',
            label: 'How did you hear of us?:',
            options: [
              { label: 'Blog Article/Link', value: 'Blog Article/Link'},
              { label: 'Business Card', value: 'Business Card'},
              { label: 'Email Link', value: 'Email Link'},
              { label: 'Facebook Link', value: 'Facebook Link'},
              { label: 'Internet Advertisement', value: 'Internet Advertisement'},
              { label: 'Repeat Business', value: 'Repeat Business'},
              { label: 'Search Engine', value: 'Search Engine'},
              { label: 'Twitter Link', value: 'Twitter Link'},
              { label: 'Word of Mouth', value: 'Word of Mouth'},
              { label: 'Other', value: 'Other'}
            ],
            mapping: 'reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Small',
            label: 'Additional Notes:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'Medium',
            label: 'GET A QUOTE'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Corkys-Simply Delicious Caterings Contact Form',
    formId: '203',
    clientKey: '41417412-59FD-4A40-AAAC-F46273A7DC7C',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /Users/kevin/projects/inquiry-renderer/client_forms/corkys/form_structure.js